export default (
	source,
	multi_select = false,
	active = false,
	default_value = '',
) => ({
	selected_value: default_value,
	selected_values: [],
	options: [],
	active,
	init() {
		try {
			const options_text = this.$refs?.options?.textContent;
			if ( options_text ) { this.options = JSON.parse(options_text); }
		} catch (error) {
			console.error(`Can't parse options data: `, error); // eslint-disable-line no-console
		}

		if ( multi_select ) {
			if (default_value) { this.selected_values.push(default_value); }
			this.setupMultiWatches();
		} else {
			this.setupSingleWatches();
		}
	},
	filterSelected() {
		const key = this.$event.detail.key;
		if ( key !== 'industries' ) { return; }

		this.active = true;
		this.selected_values = [];
	},
	setupSingleWatches() {
		this.$watch(
			'selected_value',
			value => this.$dispatch('filter', { key: source, value })
		);
	},
	setupMultiWatches() {
		this.$watch(
			'selected_values',
			value => this.$dispatch('filter', { key: source, value })
		);
	}
});
